/* ----- ▼ ヘッダー・フッター ▼ ----- */
// 「お問い合わせ」を新しいウィンドウで表示する
$('a[href="https://cook-takakura.co.jp/contact/"]').click(function(){
  window.open('https://cook-takakura.co.jp/contact/', '_blank');
  return false;
});
// フッター左のブランドロゴからトップページにリンク
$(function(){
  $('.footer-block__brand-info img').wrap($('<a>').attr('href', '/'));
});

/* -----　▼ トップページ ▼ ----- */
/* ----- 縦書きキャッチコピーに改行を挿入 ----- */
$('#shopify-section-template--21048898388268__image_with_text_HbMMUK h2').html("体と心に<br>優しいお惣菜");
/* ----- 「LINEUP」の見出しにID「#all-items」を付与 ----- */
$("#shopify-section-template--21048898388268__rich_text_ebK968 h2").attr("id", "all-items");
/* ----- 商品名に改行を挿入 ----- */
$('#shopify-section-template--21048898388268__featured_product_ywq76r h2').html("たかくらのおすすめ<br>5点セット");
$('#shopify-section-template--21048898388268__featured_product_zwVRrg h2').html("選べるお惣菜<br class='br-pc'>5点セット");
$('#shopify-section-template--21048898388268__featured_product_gK43qY h2').html("選べるお惣菜<br class='br-pc'>10点セット");
/* ----- 「選べるお惣菜」の見出しにID「#lineup」を付与 ----- */
$("#shopify-section-template--21048898388268__be97a1a0-b225-4e85-b8df-853de8d91998 div").attr("id", "lineup");
